
window.addEventListener('DOMContentLoaded', () => {
    //Get UTM Parameters
    const checkUTMParams = JSON.parse(localStorage.getItem('utm_params'));
    if (!checkUTMParams) {
        const url_string = window.location.href
        let url = new URL(url_string);
        const utm_campaign = url.searchParams.get("utm_campaign");
        const utm_content = url.searchParams.get("utm_content");
        const utm_medium = url.searchParams.get("utm_medium");
        const utm_source = url.searchParams.get("utm_source");
        const utm_term = url.searchParams.get("utm_term");

        const data = {
            'utm_campaign': `${utm_campaign}`,
            'utm_content': `${utm_content}`,
            'utm_medium': `${utm_medium}`,
            'utm_source': `${utm_source}`,
            'utm_term': `${utm_term}`
        }
        localStorage.setItem('utm_params', JSON.stringify(data));
    }
});

// Get the modal
var modal = document.getElementById("myModal");

// Get the button that opens the modal
var btn = document.getElementById("myBtn");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];

// When the user clicks the button, open the modal 
btn.onclick = function () {
  modal.style.display = "block";
}

// When the user clicks on <span> (x), close the modal
span.onclick = function () {
  modal.style.display = "none";
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function (event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}
